import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-16">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p>&copy; 2025 Haircare & Relaxation. Tous droits réservés.</p>
      </div>
    </footer>
  );
}